<template>
  <v-row justify="center" style="z-index: 9999">
    <v-dialog
      :value="value"
      width="65%"
      max-width="100%"
      @click:outside="close"
    >
      <v-card class="d-flex flex-column" style="max-height: 90vh">
        <v-card-title class="mb-0">
          <span>{{ $t("select_location") }}</span>
          <v-spacer></v-spacer>
          <v-btn icon @click="close">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>

        <v-card-text
          class="ma-0 pa-0 d-flex align-center justify-center"
          style="
            flex: 1;
            min-height: 40vh;
            position: relative;
            overflow: hidden;
          "
        >
          <v-progress-circular
            v-if="searching"
            indeterminate
            color="primary"
            size="40"
          ></v-progress-circular>

          <div
            v-else
            id="map"
            class="map"
            style="width: 100%; height: 60vh; min-height: 40vh"
          ></div>
        </v-card-text>

        <v-card-actions class="justify-end">
          <v-btn
            color="grey lighten-2"
            class="ma-2 text-black-color"
            @click="close"
            >{{ $t("cancel") }}
            <v-icon dark right> mdi-keyboard-return</v-icon></v-btn
          >
          <v-btn class="ma-2 text-white-color" color="success" @click="confirm"
            >{{ $t("ok") }}
            <v-icon dark right> mdi-check</v-icon>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import { Map, Marker, NavigationControl } from "maplibre-gl";

export default {
  name: "SimpleMapSelector",
  props: {
    modelValue: {
      type: Array, // [lng, lat]
      default: () => [77.216721, 28.6448],
    },
    value: {
      type: Boolean,
      default: false,
    },
    searching: {
      type: Boolean,
      default: false,
    },
    providedAddressForMap: {
      type: Object,
      default: null,
    },
  },
  emits: ["update:modelValue", "update:value", "address"],
  data() {
    return {
      map: null,
      marker: null,
      tempCoords: null,

      selectedAddress: {
        street: null,
        building_id: null,
        place_id: null,
        zip: null,
        country: null,
        country_code: null,
        country_id: null,
        county: null,
        state: null,
        region: null,
        city: null,
        lat: null,
        long: null,
        provider: null,
        formatted: null,
        name: null,
        location_name: null,
      },
      defaultCoords: [], // Luxembourg
    };
  },
  watch: {
    providedAddressForMap: {
      handler(val) {
        if (val && typeof val == "object") {
          this.defaultCoords = [val.long, val.lat];
          this.initMap();
        }
      },
      immediate: true,
    },
    value: {
      handler(val) {
        if (val) this.initMap();
      },
      immediate: true,
    },
  },
  activated() {
    this.defaultCoords = [6.1296, 49.6117]; // Luxembourg
  },
  mounted() {
    this.defaultCoords = [6.1296, 49.6117]; // Luxembourg
  },
  methods: {
    close() {
      this.$emit("update:value", false);
    },
    confirm() {
      if (this.tempCoords) {
        this.$emit("update:modelValue", this.tempCoords);
        this.$emit("address", this.selectedAddress);
      }
      this.close();
    },
    async reverseGeocode(lat, lon) {
      try {
        const url = `https://api.geoapify.com/v1/geocode/reverse?lat=${lat}&lon=${lon}&apiKey=${this.mapApiKey}`;
        const response = await fetch(url);
        const data = await response.json();

        const result = data?.features?.[0]?.properties || {};
        let normalizedResponse = result
          ? this.normalizeOpenStreetMapResponse([result])
          : null;
        this.selectedAddress =
          normalizedResponse && normalizedResponse.length > 0
            ? normalizedResponse[0]
            : null;
      } catch (error) {
        console.error("Geoapify reverse geocoding failed", error);
      }
    },
    initMap() {
      if (this.searching) {
        return true;
      }
      this.$nextTick(() => {
        if (this.map) {
          this.map.resize();
          return;
        }

        const center =
          Array.isArray(this.modelValue) && this.modelValue.length === 2
            ? this.modelValue
            : this.defaultCoords;

        this.tempCoords = center;

        this.map = new Map({
          container: "map",
          style:
            "https://api.maptiler.com/maps/streets-v2/style.json?key=f4IJi1mRlspltChrcUM3",
          center,
          zoom: 13,
        });

        this.map.addControl(new NavigationControl());

        this.marker = new Marker().setLngLat(center).addTo(this.map);

        this.reverseGeocode(center[1], center[0]);

        this.map.on("click", (e) => {
          const coords = [e.lngLat.lng, e.lngLat.lat];
          this.tempCoords = coords;

          if (this.marker) {
            this.marker.setLngLat(coords);
          } else {
            this.marker = new Marker().setLngLat(coords).addTo(this.map);
          }

          this.reverseGeocode(coords[1], coords[0]);
        });

        setTimeout(() => {
          this.map.resize();
        }, 300);
      });
    },
  },
};
</script>

<style>
.map {
  width: 100%;
  height: 100%;
}
</style>
